// extracted by mini-css-extract-plugin
export var active = "_d4-7";
export var container = "_d4-0";
export var evenWidth = "_d4-4";
export var large = "_d4-5";
export var outlet = "_d4-8";
export var slide = "_d4-2";
export var small = "_d4-6";
export var tab = "_d4-3";
export var tabs = "_d4-1";